import { createFileRoute, redirect } from "@tanstack/react-router";

// Alamat lama /admin/ai-assistant (satu halaman panjang) diarahkan ke sub menu pertama.
export const Route = createFileRoute("/admin/ai-assistant/")({
	beforeLoad: () => {
		throw redirect({ to: "/admin/ai-assistant/umum", replace: true });
	},
});
